'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rootPath = exports.businessRealmCookiePrefix = exports.tvCodeExpirySessionStorageName = exports.tvCodeSessionStorageName = exports.linkAccountCookie = exports.operatorIdCookie = exports.deviceId = exports.currentLanguage = exports.lastLoginLogoutTime = exports.loginSessionIdName = exports.deprecatedSessionIdName = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.getCookieDomain = getCookieDomain;
exports.default = buildCookieNameFromPrefix;
exports.getCookieValue = getCookieValue;
exports.setCookie = setCookie;
exports.deleteCookie = deleteCookie;
exports.readAndSaveDeviceId = readAndSaveDeviceId;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _Product = require('./Product');

var _Guid = require('./Guid');

var _Guid2 = _interopRequireDefault(_Guid);

var _config = require('./../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var deprecatedSessionIdName = exports.deprecatedSessionIdName = 'sid'; // deprecated
var loginSessionIdName = exports.loginSessionIdName = 'ul_sid';
var lastLoginLogoutTime = exports.lastLoginLogoutTime = 'ul_lst';
var currentLanguage = exports.currentLanguage = 'clang';
var deviceId = exports.deviceId = 'u_did';
var operatorIdCookie = exports.operatorIdCookie = 'opeId';
var linkAccountCookie = exports.linkAccountCookie = 'lnAc';
var tvCodeSessionStorageName = exports.tvCodeSessionStorageName = 'tvCode';
var tvCodeExpirySessionStorageName = exports.tvCodeExpirySessionStorageName = "tvCodeExpiry";

var generalCookies = [deviceId];
var realmCookies = [deprecatedSessionIdName, loginSessionIdName, lastLoginLogoutTime, currentLanguage, linkAccountCookie];

var businessRealmCookiePrefix = exports.businessRealmCookiePrefix = 'b_';
var rootPath = exports.rootPath = '/';

function getCookieDomain() {
  return _config2.default.envPrefix === 'local_' ? '' : '.stingray.com';
}

function buildCookieNameFromPrefix(prefix, baseName, realm) {
  var isRealmCookie = realmCookies.indexOf(baseName) > -1;
  var cookieRealmPrefix = '';
  console.assert(generalCookies.indexOf(baseName) > -1 || isRealmCookie, 'Unsupported Cookie name = ' + baseName);

  if (isRealmCookie) {
    switch (realm) {
      case _Product.REALM_NAMES.Business:
        cookieRealmPrefix = businessRealmCookiePrefix;
        break;
      default:
        break;
    }
  }

  return isRealmCookie ? cookieRealmPrefix + prefix + baseName : baseName;
}

function getCookieValue(name) {
  var defaultValue = '; ' + document.cookie;
  var parts = defaultValue.split('; ' + name + '=');
  var value = '';

  if (parts.length === 2) {
    value = parts.pop().split(';').shift();
  }
  return value;
}

function setCookie(name, value, options) {
  var cookieString = name + '=' + value;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(options)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
          key = _step$value[0],
          _value = _step$value[1];

      cookieString += ';' + key + '=' + _value;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  document.cookie = cookieString;
}

function deleteCookie(name) {
  var cookieString = name + '=';
  var expiryDate = new Date();
  expiryDate.setTime(expiryDate.getTime() - 86400 * 1000);
  cookieString += ';max-age=0';
  cookieString += ';expires=' + expiryDate.toUTCString();
  cookieString += ';path=/';
  document.cookie = cookieString;
}

function saveDeviceId(cookieName, userDeviceId) {
  var expireDate = new Date((0, _moment2.default)().add(5, 'years').toDate());
  var cookieString = cookieName + '=' + userDeviceId + '; expires=' + expireDate + '; path=' + rootPath + '; domain=' + getCookieDomain();
  document.cookie = cookieString;
}

function readAndSaveDeviceId(env, realm) {
  var cookieName = buildCookieNameFromPrefix(env, deviceId, realm);
  var userDeviceId = getCookieValue(cookieName) || (0, _Guid2.default)();

  saveDeviceId(cookieName, userDeviceId);

  return userDeviceId;
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Cookie.js
// module id = 60
// module chunks = 0